import {Component} from '@angular/core';
import {RequestSupportDialogComponent} from '../request-support-dialog/request-support-dialog.component';
import {MdDialog} from '@angular/material';
import {RequestSupportService} from '../../services/request-support/request-support.service';
import {ConfirmationDialogService} from '../../services/confirmation-dialog/confirmation-dialog.service';
import {SupportRequest} from '../../interfaces/SupportRequest';
import * as Raven from 'raven-js';

@Component({
  selector: 'app-request-support-button',
  templateUrl: './request-support-button.component.html',
  styleUrls: ['./request-support-button.component.scss']
})
export class RequestSupportButtonComponent {
  constructor(public dialog: MdDialog,
              public request: RequestSupportService,
              public confirmation: ConfirmationDialogService) { }

  openDialog() {
    this.dialog.open(RequestSupportDialogComponent, { disableClose: true }).afterClosed().subscribe(async result => {
      if (result !== 'cancel') {
         await this.sendSupportRequest(result);
      }
    });
  }

  async sendSupportRequest(request: SupportRequest) {
    try {
      await this.request.SendSupportRequestEmail(request);
      this.confirmation.openDialog( true);
    } catch (e) {
      Raven.captureException(e);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/request-support/request-support-button.component.ts